export { ISunmiPrinterService } from './sunmi-printer.service';
export { sunmiPrinterServiceFactory } from './sunmi-printer.service.factory';
